import UsersPending from './UsersPending';
export default UsersPending;
